import { render, staticRenderFns } from "./ListAnnotationsAlgo.vue?vue&type=template&id=505ebc2c&scoped=true"
import script from "./ListAnnotationsAlgo.vue?vue&type=script&lang=js"
export * from "./ListAnnotationsAlgo.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotationsAlgo.vue?vue&type=style&index=0&id=505ebc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ebc2c",
  null
  
)

export default component.exports